import React, { Component } from "react";
import PropTypes from "prop-types";
import Pagination from "react-js-pagination";

class PaginationAdvanced extends Component {
  static propTypes = {
    handle: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    per_page: PropTypes.number.isRequired
  };

  constructor(props) {
    super(props);
    this.state = { per_page: null, page: 1 };
  }

  handleSelect(page_number) {
    if (this.props.handle) {
      this.props.handle(page_number, this.props.per_page);
    }
  }

  selectItemNum(event) {
    localStorage.setItem("per_page", event.target.value);
    if (this.props.handle) {
      if (this.props.handle) {
        this.props.handle(1, event.target.value);
      }
    }
  }

  render() {
    let perPageAmounts = [10, 25, 100];
    let per_page = this.props.per_page || 25;
    let maxButtons = 10 > this.props.total ? this.props.total : 10;
    let perPageOptions = perPageAmounts.map(perPageAmount => {
      return (
        <option key={perPageAmount} value={perPageAmount}>
          {perPageAmount}
        </option>
      );
    });
    return (
      <div>
        <Pagination
          activePage={Number.parseInt(this.props.page)}
          itemsCountPerPage={Number(per_page)}
          totalItemsCount={this.props.total}
          pageRangeDisplayed={maxButtons}
          onChange={this.handleSelect.bind(this)}
        />
        <select
          onChange={this.selectItemNum.bind(this)}
          value={Number(per_page)}
          className="pagination_select form-control m-l-10 input pull-right"
        >
          {perPageOptions}
        </select>
      </div>
    );
  }
}

export default PaginationAdvanced;
